const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/RootFrame.tsx';
import { Component } from 'react';
import { Provider } from 'react-redux';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import configureStore from 'App/store/setup/configureStore';
import { IntlProvider } from '@cistec/common_web/layout/IntlProvider';
import { PatAppRouter } from '../PatAppRouter';
import { PageErrorBoundary } from '@cistec/common_web/components/PageErrorBoundary/PageErrorBoundary';
import PickersUtilsProvider from '@cistec/common_web/layout/PickersUtilsProvider';
import { theme } from 'App/utils/clientSetupManager';
import { isMatomoEnabled } from 'App/utils/matomo';
import { TrackingState } from 'App/defs/trackingDefs';
import { trackingSelector } from 'App/store/tracking';

const AppState = configureStore();

interface IRootFrameProps {}

interface IRootFrameState {
    trackingState: string;
}

export class RootFrame extends Component<IRootFrameProps, IRootFrameState> {
    constructor(props: IRootFrameProps) {
        super(props);
    }

    public override componentDidMount() {
        const splashNode = document.getElementById('splash');

        if (splashNode?.parentNode) {
            splashNode.parentNode.removeChild(splashNode);
        }
    }

    public override render() {
        return (
            <Provider store={AppState as any}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                        <IntlProvider>
                            <PickersUtilsProvider>{this.renderMatomoProvider()}</PickersUtilsProvider>
                        </IntlProvider>
                    </ThemeProvider>
                </StyledEngineProvider>
            </Provider>
        );
    }

    private static renderPageErrorBoundary() {
        return (
            <PageErrorBoundary>
                <PatAppRouter />
            </PageErrorBoundary>
        );
    }

    private renderMatomoProvider() {
        if (isMatomoEnabled && (trackingSelector(AppState?.getState()) as any) === TrackingState.AGREE) {
            const MatomoProvider = require('@datapunt/matomo-tracker-react').MatomoProvider;
            const matomoInstance = require('App/utils/matomo').matomoInstance;

            if (MatomoProvider && matomoInstance) {
                return <MatomoProvider value={matomoInstance}>{RootFrame.renderPageErrorBoundary()}</MatomoProvider>;
            } else {
                return RootFrame.renderPageErrorBoundary();
            }
        } else {
            return RootFrame.renderPageErrorBoundary();
        }
    }
}
